import i18n from 'i18n-js';

import en from './LangTranslations/en.json';
import cz from './LangTranslations/cz.json';
i18n.fallbacks = true;
i18n.translations = { cz, en}; 

export default i18n;